import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import TabbedView from "../../App/Components/TabbedView/TabbedView";
import GeneralReport from "./Components/GeneralReport";
import { getAdTypes } from "./ReportsService";
import TypeReport from "./Components/TypeReport";
import { JobGroups } from "../../App/Enums/JobGroups";
import YearMonthDayPicker from "../../App/Components/Datepickers/YearMonthDayPicker";
import { useReportDateState } from "./State/ReportDateState";

function ReportsPage(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      height: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        paddingBottom: "80px",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    if (selectCareersClient !== null) {
      getAdTypes(selectCareersClient.id).then((response) => {
        initializeTabs(response);
      });
    }
  }, [selectCareersClient, props]);

  function initializeTabs(adTypes) {
    const tempTabs = [];
    tempTabs.push({
      title: "Full Report",
      component: <GeneralReport adTypes={adTypes} optIn={props.props.optIn} />,
    });
    if (adTypes.industries.length > 0) {
      tempTabs.push({
        title: "By Industry",
        component: (
          <TypeReport
            allTypes={adTypes.industries}
            type={JobGroups.Industry}
            label="Industry"
            optIn={props.props.optIn}
          />
        ),
      });
    }
    if (adTypes.families.length > 0) {
      tempTabs.push({
        title: "By Family",
        component: (
          <TypeReport
            allTypes={adTypes.families}
            type={JobGroups.Family}
            label="Family"
            optIn={props.props.optIn}
          />
        ),
      });
    }
    if (adTypes.categories.length > 0) {
      tempTabs.push({
        title: "By Category",
        component: (
          <TypeReport
            allTypes={adTypes.categories}
            type={JobGroups.Category}
            label="Category"
            optIn={props.props.optIn}
          />
        ),
      });
    }
    setTabs(tempTabs);
  }

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {props.props.optIn
            ? selectCareersClient.shortName + " Marketing Report"
            : selectCareersClient.shortName + " Job Alert Report"}
        </h1>
        <div className={classes.root}>
          {selectCareersClient === null ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <TabbedView tabs={tabs} />
          )}
        </div>
      </div>
    </>
  );
}

export default ReportsPage;
